import React from 'react';

import HeaderImage from './index';

import Small from '../../../../assets/images/headers/blog/small.png'
import Big from '../../../../assets/images/headers/blog/big.png'

const BlogHeaderImage = (props: { width: number }) => (
    <HeaderImage width={props.width} small={Small} big={Big}/>
);

export default BlogHeaderImage
